import React, { Component } from "react";
import { connect } from "react-redux";
import { updateThrottleValve } from "../actions/";

class ThrottleValve extends Component {
  constructor(props) {
    super(props);
    this.state = {
      throttleValve: [
        {
          value: "without brake test valve",
          orderCode: "0"
        },
        {
          value: "with brake test valve",
          orderCode: "1"
        }
      ]
    };
    this.handleOnchange = this.handleOnchange.bind(this);
  }

  handleOnchange = selected => {
    this.props.onThrottleValveSelect(JSON.parse(selected.target.value));
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.winchType !== this.props.winchType ||
      this.props.previewStatus !== prevProps.previewStatus ||
      this.props.motorType !== prevProps.motorType
    ) {
      if (this.props.winchType.orderCode !== prevProps.winchType.orderCode) {
        this.props.onThrottleValveSelect({
          value: "without brake test valve",
          orderCode: "0"
        });
        var ele = document.getElementsByName("throttleValve");
        for (var i = 0; i < ele.length; i++) ele[i].checked = false;
        ele[0].checked = true;
      }
      //   if (this.props.motorType.orderCode !== "PM049") {
      this.setState({
        throttleValve: [
          {
            value: "without brake test valve",
            orderCode: "0"
          },
          {
            value: "with brake test valve",
            orderCode: "1"
          }
        ]
      });
      /* } else {
         this.setState({
           throttleValve: [
             {
               value: "without brake test valve",
               orderCode: "0"
             }
           ]
         });
       }*/
    }
  }

  componentDidMount() {
    if (this.props.previewStatus !== "show") {
      this.props.onThrottleValveSelect({
        value: "without brake test valve",
        orderCode: "0"
      });
    }
  }

  render() {
    var throttleValve = this.state.throttleValve.map((tv, index) => {
      return (
        <div className="col-md-6" key={index}>
          <label>
            <input
              type="radio"
              value={JSON.stringify(tv)}
              name="throttleValve"
              defaultChecked={
                this.props.throttleValve.orderCode
                  ? this.props.throttleValve.orderCode === tv.orderCode
                  : index === 0
              }
            />{" "}
            {tv.value}
          </label>
        </div>
      );
    });
    return (
      <div>
        <div className="field-top">Brake test valve</div>
        <div className="selection-body">
          <p>
            In order to perform a brake test, the winch can be equipped with a
            brake test valve.
            {/* With this valve, a winch brake test according API 2C
            specification can be performed. */}
          </p>
          <div className="row" onChange={this.handleOnchange}>
            {throttleValve}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    motorType: state.motorType,
    winchType: state.winchType,
    previewStatus: state.previewStatus,
    throttleValve: state.throttleValve
  };
};

const mapActionsToProps = {
  onThrottleValveSelect: updateThrottleValve
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(ThrottleValve);



// WEBPACK FOOTER //
// ./src/components/throttleValve.js